import { useRouter } from 'next/router';

import { Box, Heading, Paragraph, PropertyCard } from '@zillow/constellation-10';

import { useGetListingDetails } from '../../hooks/queries/properties';
import propertyUtils from '../../utils/propertyUtils';

import { propertyPhotoStyles } from '../../../srcLegacy/shared/components/WizardModularListing/Review/styles';
import { AccordionStateButton } from '../../components/ListingDetails/AccordionStateButton';

import { singleTextLineStyles } from '../../styles/text';
import { containerStyles, pageContentStyles } from './styles';

export const TOP_OFFSET = 256;

type Props = {
  isListingHeaderVisible?: boolean;
  isFixedPosition?: boolean;
};
const AccordionStateHeader = ({ isListingHeaderVisible = true, isFixedPosition }: Props) => {
  const router = useRouter();

  const { listingAlias } = router.query as { listingAlias: string };

  const { data: listingDetails, isPending: isListingDetailsLoading } = useGetListingDetails(listingAlias);
  const isSelfServeOnboardingInProgress = listingDetails?.selfServeOnboardingStatus?.isSelfServeOnboardingInProgress;

  const { formattedCompleteAddress } = propertyUtils.formatAddress({
    street: listingDetails?.street,
    city: listingDetails?.city,
    state: listingDetails?.state,
    zip: listingDetails?.zip,
  });

  return (
    <Box
      css={containerStyles.raw({
        isFixedPosition,
      })}
      data-testid="AccordionStateHeader"
    >
      <Box css={pageContentStyles}>
        <Box css={{ display: 'flex', flexDirection: isSelfServeOnboardingInProgress ? 'column' : 'row' }}>
          {isSelfServeOnboardingInProgress && (
            <>
              <Paragraph textStyle="body-sm-bold">Step 4 of 4</Paragraph>
              <Heading level={4}>Listing details</Heading>
            </>
          )}
          {isFixedPosition && (
            <>
              <Box css={{ overflow: 'hidden', display: { base: 'none', xl: 'block' }, ...propertyPhotoStyles }}>
                <PropertyCard.Photo
                  src={listingDetails?.primaryPhoto?.url ?? undefined}
                  alt="property"
                  fallbackImg={<PropertyCard.PhotoFallback />}
                  css={{ width: '100%', height: '104px' }}
                />
              </Box>

              <Box css={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', minWidth: 0 }}>
                <Heading level={3}>{listingDetails?.name || listingDetails?.street}</Heading>
                <Paragraph
                  css={{
                    ...singleTextLineStyles,
                  }}
                >
                  {formattedCompleteAddress}
                </Paragraph>
              </Box>
            </>
          )}
        </Box>
        <Box css={{ display: 'flex', marginRight: '200' }}>
          <AccordionStateButton isVisible={!isListingHeaderVisible} disabled={isListingDetailsLoading} />
        </Box>
      </Box>
    </Box>
  );
};

export default AccordionStateHeader;
